import { Component, Input, OnInit } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { isUndefined } from 'util';

@Component({
  selector: 'app-valore-punti-erogati-indicator',
  templateUrl: './valore-punti-erogati-indicator.component.html',
  styleUrls: ['./valore-punti-erogati-indicator.component.css']
})
export class ValorePuntiErogatiIndicatorComponent implements OnInit {

  @Input() data: any;

  constructor(
    private indicatorService: IndicatorsService
  ) { }

  ngOnInit() {
    if (!isUndefined(this.data)) {
      this.indicatorService.indicatorCalculation('ValorePuntiErogati', this.data).subscribe((res) => {
        console.log('ValorePuntiErogati', res);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/valore-punti-erogati-indicator/valore-punti-erogati-indicator.component.ts